import type { SetlistContext } from './client';
import { STOCK_VIDEO_COLLECTION } from './collections';
import type { VideoDocument } from './stock-video-types';

export const fetchBatchStockVideos = async (
  context: SetlistContext,
  {
    batchId,
    currentAssetId,
    page,
    resultsPerPage = 12,
  }: {
    batchId: number;
    currentAssetId: string;
    page: number;
    resultsPerPage?: number;
  }
) => {
  // Filter by batch_id and exclude the current asset
  const filterString = `batch_id:=${batchId} && id:!=${currentAssetId}`;

  const searchParams = {
    q: '*',
    query_by: 'title',
    filter_by: filterString,
    page,
    per_page: resultsPerPage,
  };

  const response = await context.client
    .collections(STOCK_VIDEO_COLLECTION)
    .documents()
    .search(searchParams, {});

  const { page: currentPage, found, hits } = response;

  let hasMore = false;

  if (hits) {
    hasMore = resultsPerPage * (currentPage - 1) + hits.length < found;
  }

  if (!hits || hits.length === 0) {
    return {
      data: [],
      hasMore: false,
    };
  }

  return {
    data: response?.hits?.map((hit) => hit.document as VideoDocument) ?? [],
    hasMore,
  };
};
